// extracted by mini-css-extract-plugin
export default {"list-item":"property-card_list-item__Zc8qu","list-container":"property-card_list-container__h0KG9","container":"property-card_container__LVUyZ"};